import type { SVGProps } from 'react';
export const DesktopSmall = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1rem" height="1rem" fill="currentColor" viewBox="0 0 20 20" {...props}>
    <path
      fillRule="evenodd"
      d="M4.67 4.27c-.25 0-.47.22-.47.52v5.73h11.6V4.8c0-.3-.22-.52-.47-.52zM17 11.15V4.79C17 3.82 16.27 3 15.33 3H4.67C3.73 3 3 3.82 3 4.8v8.1c0 .97.73 1.79 1.67 1.79H9.4v1.04H7.87c-.33 0-.6.28-.6.63 0 .36.27.64.6.64h4.26c.33 0 .6-.28.6-.64 0-.35-.27-.63-.6-.63H10.6v-1.04h4.73c.94 0 1.67-.82 1.67-1.8v-1.74m-1.2.64H4.2v1.1c0 .3.22.52.47.52h10.66c.25 0 .47-.22.47-.52z"
      clipRule="evenodd"
    />
  </svg>
);
